// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Bnf9R","button":"styles_button__M9lpf"};